(function () {
  'use strict';

  var fieldset = document.getElementById('product-purchase-options');
  if (!fieldset) return;

  var BUNDLE_TIER = fieldset.dataset.bundleTier || '';
  var BUNDLE_HANDLE = fieldset.dataset.bundleHandle || 'bundle-save';
  var BUNDLE_PCT = parseInt(fieldset.dataset.bundlePct || '0', 10);
  var PRODUCT_HANDLE = fieldset.dataset.productHandle || '';
  var SELLING_PLAN_ID = parseInt(fieldset.dataset.sellingPlanId || '0', 10);

  // MJ: piece 1 price is read live and re-read on every variant change.
  var PIECE1_PRICE = parseInt(fieldset.dataset.oneTimePrice || '0', 10);

  var slot2 = null;
  var collectionProducts = [];
  var pickModal = null;

  window.mjSelectedOption = window.mjSelectedOption || (BUNDLE_TIER ? 'bundle' : 'onetime');

  // Prices arrive in two shapes. Variant objects from the theme use integer
  // cents (9900). /collections/*/products.json uses decimal strings ("99.00").
  // Everything downstream works in cents, so normalise once, here.
  function toCents(p) {
    if (p === null || typeof p === 'undefined' || p === '') return 0;
    if (typeof p === 'number') return Math.round(p);
    var s = String(p);
    return s.indexOf('.') > -1 ? Math.round(parseFloat(s) * 100) : parseInt(s, 10);
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function getForm() {
    return document.querySelector('#product-template form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantId() {
    var form = getForm();
    var input = form && form.querySelector('[name="id"]');
    return input ? parseInt(input.value, 10) : parseInt(fieldset.dataset.variantId, 10);
  }

  // ---- MJ bundle pricing -------------------------------------------------
  // Percentage off both pieces, derived from two live variant prices.
  // Nothing about price is hardcoded anywhere in this file.

  function slot2PriceCents() {
    if (!slot2 || !slot2.variants) return 0;
    var chosen = null;
    for (var i = 0; i < slot2.variants.length; i++) {
      if (slot2.variants[i].id === slot2._selectedVariantId) { chosen = slot2.variants[i]; break; }
    }
    if (!chosen) chosen = slot2.variants[0];
    return chosen ? toCents(chosen.price) : 0;
  }

  function bundleTotals() {
    var p1 = PIECE1_PRICE || 0;
    var p2 = slot2 ? slot2PriceCents() : p1; // before a 2nd piece is picked, estimate on 2 of this
    var compare = p1 + p2;
    var total = Math.round(compare * (100 - BUNDLE_PCT) / 100);
    return { compare: compare, total: total, estimated: !slot2 };
  }

  function updateBundlePrice() {
    var el = document.getElementById('mj-bundle-price');
    if (!el || !BUNDLE_TIER) return;
    var t = bundleTotals();
    var html = '<strong>' + formatMoney(t.total) + '</strong>';
    if (t.compare > t.total) html += '<s>' + formatMoney(t.compare) + '</s>';
    el.innerHTML = html;
  }

  function getProductImage(product, size) {
    if (!product.images || !product.images.length) return '';
    return product.images[0].src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + '$1$3');
  }

  function updateSlot1(variant) {
    var slot = document.getElementById('mj-bb-slot-1');

    if (variant && typeof variant.price !== 'undefined') {
      PIECE1_PRICE = toCents(variant.price);
      fieldset.dataset.oneTimePrice = PIECE1_PRICE;
      updateBundlePrice();
    }

    if (!slot) return;

    var img = slot.querySelector('.mj-slot-thumb img');
    var title = slot.querySelector('.mj-slot-title');

    if (variant) {
      fieldset.dataset.variantId = variant.id;
      if (img) {
        var src = null;
        if (variant.featured_image) {
          src = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
        }
        if (src) {
          img.src = src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_160x$1$3');
          img.alt = variant.name || fieldset.dataset.productTitle;
        }
      }
      if (title && variant.title && variant.title !== 'Default Title') {
        title.textContent = variant.title;
      }
    }
  }

  function getChosenOption() {
    var checked = fieldset.querySelector('[name="purchase_option"]:checked');
    if (!checked) return window.mjSelectedOption || 'onetime';
    if (checked.id === 'purchase-options-bundle') return 'bundle';
    if (checked.id === 'purchase-options-subscription') return 'subscription';
    if (checked.id === 'purchase-options-one-time') return 'onetime';
    return checked.value;
  }

  function syncSellingPlanField(chosen) {
    var spInput = document.getElementById('purchase-delivery-options-select');
    if (!spInput) return;
    var isSub = chosen === 'subscription';
    if (!isSub) {
      spInput.disabled = true;
      spInput.removeAttribute('name');
    } else {
      spInput.disabled = false;
      spInput.setAttribute('name', 'selling_plan');
    }
  }

  function updateAtcLabel() {
    var btnText = document.querySelector('.btn-atc .btn-atc-text');
    if (!btnText) return;

    if (window.mjSelectedOption === 'subscription') {
      btnText.textContent = 'Add to Cart — Start My Journey';
    } else if (window.mjSelectedOption === 'bundle' && BUNDLE_TIER) {
      if (slot2) {
        btnText.textContent = 'Add 2 pieces · ' + formatMoney(bundleTotals().total) + ' total';
      } else {
        btnText.textContent = 'Add this piece';
      }
    } else {
      var btn = btnText.closest('.btn-atc');
      btnText.textContent = btn && btn.dataset.textAddToCart ? btn.dataset.textAddToCart : 'Add To Cart';
    }
  }

  function toggleComposition(show) {
    var expand = document.getElementById('mj-bundle-builder');
    var bundleRow = document.getElementById('mj-card-bundle');
    if (expand) expand.hidden = !show;
    if (bundleRow) bundleRow.classList.toggle('mj-stack-row--expanded', show);
  }

  function toggleSubscribeExpand(show) {
    var expand = document.getElementById('purchase-delivery-options');
    var subRow = document.getElementById('mj-card-subscription');
    if (expand) expand.hidden = !show;
    if (subRow) subRow.classList.toggle('mj-stack-row--expanded', show);
  }

  function renderSlot2Filled() {
    var el = document.getElementById('mj-bc-slot2');
    if (!el || !slot2) return;

    var imgSrc = getProductImage(slot2, '160x');
    var hasVariants = slot2.variants.length > 1 && slot2.variants[0].title !== 'Default Title';

    el.className = 'mj-slot-row mj-slot-row--filled';

    var html = '<div class="mj-slot-thumb">'
      + (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(slot2.title) + '" width="48" height="48">' : '')
      + '</div>'
      + '<div class="mj-slot-info">'
      + '<span class="mj-slot-title">' + escapeHtml(slot2.title) + '</span>';

    if (hasVariants) {
      html += '<select class="mj-slot-variant" id="mj-bc-slot2-variant" aria-label="Second piece variant">';
      slot2.variants.forEach(function (v) {
        html += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === slot2._selectedVariantId ? ' selected' : '') + '>'
          + escapeHtml(v.title) + (v.available ? '' : ' (Sold out)') + '</option>';
      });
      html += '</select>';
    } else {
      html += '<span class="mj-slot-hint">Piece 2</span>';
    }

    html += '</div>'
      + '<button type="button" class="mj-slot-action mj-slot-action--ghost" id="mj-bc-open-modal">Change</button>';

    el.innerHTML = html;

    var sel = el.querySelector('#mj-bc-slot2-variant');
    if (sel) {
      sel.addEventListener('change', function () {
        slot2._selectedVariantId = parseInt(sel.value, 10);
        updateBundlePrice();
        updateAtcLabel();
      });
    }
    bindOpenModal(el.querySelector('#mj-bc-open-modal'));
  }

  function bindOpenModal(btn) {
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      openPickModal();
    });
  }

  function openPickModal() {
    if (!pickModal && window.bootstrap) {
      pickModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('mj-bundle-pick-modal'));
    }
    if (collectionProducts.length) {
      renderModalList();
      if (pickModal) pickModal.show();
    } else {
      loadCollectionProducts(true);
    }
  }

  // MJ: filter the picker so a 60-piece collection stays usable.
  function applyModalFilter() {
    var input = document.getElementById('mj-bpm-search-input');
    var q = input ? input.value.trim().toLowerCase() : '';
    var shown = 0;
    var items = document.querySelectorAll('#mj-bundle-pick-list .mj-bpm-item');
    Array.prototype.forEach.call(items, function (el) {
      var t = (el.getAttribute('data-title') || '').toLowerCase();
      var match = !q || t.indexOf(q) !== -1;
      el.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    var count = document.getElementById('mj-bpm-count');
    if (count) {
      count.textContent = items.length
        ? (q ? shown + ' of ' + items.length + ' pieces' : items.length + ' pieces available')
        : '';
    }
  }

  function renderModalList() {
    var list = document.getElementById('mj-bundle-pick-list');
    if (!list) return;

    if (!collectionProducts.length) {
      list.innerHTML = '<p class="mj-bb-loading">No other pieces available in this collection.</p>';
      applyModalFilter();
      return;
    }

    list.innerHTML = collectionProducts.map(function (p, idx) {
      var imgSrc = getProductImage(p, '144x');
      var avail = p.variants.filter(function (v) { return v.available; });
      var v = avail[0] || p.variants[0];
      var hasVariants = p.variants.length > 1 && p.variants[0].title !== 'Default Title';
      var priceCents = toCents(v.price);
      var compareCents = toCents(v.compare_at_price);

      var html = '<div class="mj-bpm-item" data-idx="' + idx + '" data-title="' + escapeHtml(p.title) + '">'
        + (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '')
        + '<div class="mj-bpm-info">'
        + '<p class="mj-bpm-title">' + escapeHtml(p.title) + '</p>'
        + '<p class="mj-bpm-price"><strong>' + formatMoney(priceCents) + '</strong>'
        + (compareCents > priceCents ? ' <s>' + formatMoney(compareCents) + '</s>' : '')
        + '</p>';

      if (hasVariants) {
        html += '<label class="mj-bpm-variant-label">Variant</label>'
          + '<select class="mj-bpm-variant-select" data-idx="' + idx + '">';
        p.variants.forEach(function (vr) {
          html += '<option value="' + vr.id + '"' + (vr.available ? '' : ' disabled') + '>'
            + escapeHtml(vr.title) + (vr.available ? '' : ' (Sold out)') + '</option>';
        });
        html += '</select>';
      }

      html += '</div>'
        + '<button type="button" class="mj-bpm-choose" data-idx="' + idx + '"' + (v.available ? '' : ' disabled') + '>Choose</button>'
        + '</div>';

      return html;
    }).join('');

    list.querySelectorAll('.mj-bpm-choose').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.idx, 10);
        var product = collectionProducts[idx];
        if (!product) return;

        var sel = list.querySelector('.mj-bpm-variant-select[data-idx="' + idx + '"]');
        var variantId = sel
          ? parseInt(sel.value, 10)
          : (product.variants.find(function (v) { return v.available; }) || product.variants[0]).id;

        chooseProduct(product, variantId);
      });
    });

    applyModalFilter();
  }

  function chooseProduct(product, variantId) {
    slot2 = product;
    slot2._selectedVariantId = variantId;
    renderSlot2Filled();
    updateBundlePrice();
    updateAtcLabel();

    if (pickModal) pickModal.hide();

    var notice = document.getElementById('mj-bundle-notice');
    if (notice) {
      notice.className = 'mj-bundle-notice mj-bundle-success';
      notice.innerHTML = '&#x2705; Second piece selected · ' + formatMoney(bundleTotals().total) + ' for both. Ready to add to cart.';
      notice.style.display = 'block';
    }
  }

  function loadCollectionProducts(openAfter) {
    var list = document.getElementById('mj-bundle-pick-list');
    if (!list || !BUNDLE_HANDLE) return;

    list.innerHTML = '<p class="mj-bb-loading">Loading pieces...</p>';

    // limit 250 = Shopify max, so every product added to Bundle & Save shows up.
    fetch('/collections/' + BUNDLE_HANDLE + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        collectionProducts = (data.products || []).filter(function (p) {
          if (p.handle === PRODUCT_HANDLE) return false;
          return p.variants.some(function (v) { return v.available; });
        });
        renderModalList();
        if (openAfter && pickModal) pickModal.show();
      })
      .catch(function () {
        list.innerHTML = '<p class="mj-bb-loading">Could not load collection. <a href="/collections/' + BUNDLE_HANDLE + '">Browse collection</a></p>';
      });
  }

  window.mjSelectOption = function (chosen) {
    window.mjSelectedOption = chosen;

    ['bundle', 'onetime', 'subscription'].forEach(function (id) {
      var card = document.getElementById('mj-card-' + id);
      if (card) {
        card.classList.remove('mj-po-selected');
        card.classList.remove('mj-stack-row--expanded');
      }
    });

    var chosenCard = document.getElementById('mj-card-' + chosen);
    if (chosenCard) {
      chosenCard.classList.add('mj-po-selected');
      if (chosen === 'bundle' || chosen === 'subscription') {
        chosenCard.classList.add('mj-stack-row--expanded');
      }
    }

    var radioId = chosen === 'bundle' ? 'bundle' : chosen === 'onetime' ? 'one-time' : 'subscription';
    var radio = document.getElementById('purchase-options-' + radioId);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change'));
    }

    var notice = document.getElementById('mj-bundle-notice');
    if (notice && chosen !== 'bundle') notice.style.display = 'none';

    toggleComposition(chosen === 'bundle' && !!BUNDLE_TIER);
    toggleSubscribeExpand(chosen === 'subscription');
    syncSellingPlanField(chosen);

    updateAtcLabel();
  };

  function showCart(response) {
    if (window.refreshCartContents) window.refreshCartContents(response);
    var oc = document.getElementById('offcanvas-cart');
    if (oc && window.bootstrap) bootstrap.Offcanvas.getOrCreateInstance(oc).show();
  }

  function bundleProperty() {
    return { '_bundle_tier': 'bundle' };
  }

  function oneTimeProperty() {
    return { '_purchase_type': 'onetime' };
  }

  function submitBundle(form) {
    var variantId = getVariantId();
    if (!variantId) return;

    var items;
    if (slot2 && slot2._selectedVariantId) {
      items = [
        { id: variantId, quantity: 1, properties: bundleProperty() },
        { id: slot2._selectedVariantId, quantity: 1, properties: bundleProperty() }
      ];
    } else {
      items = [{ id: variantId, quantity: 1, properties: bundleProperty() }];
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        var notice = document.getElementById('mj-bundle-notice');
        if (notice) {
          if (slot2) {
            notice.className = 'mj-bundle-notice mj-bundle-success';
            notice.innerHTML = '&#x2705; 2 pieces added. Your ' + BUNDLE_PCT + '% bundle discount applies at checkout. <a href="/cart">View cart &rarr;</a>';
          } else {
            notice.className = 'mj-bundle-notice';
            notice.innerHTML = '&#x1F6CD;&#xFE0F; <strong>1 of 2 added.</strong> Tap <strong>Choose</strong> to pick your second piece and save ' + BUNDLE_PCT + '%.';
          }
          notice.style.display = 'block';
        }
        showCart(response);
      })
      .catch(function () { form.submit(); });
  }

  function mjCheckBundleCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var n = 0;
      (cart.items || []).forEach(function (item) {
        var t = item.properties && item.properties['_bundle_tier'];
        if (t) n += item.quantity;
      });

      document.querySelectorAll('#mj-cart-bundle-warning').forEach(function (el) {
        el.parentNode.removeChild(el);
      });

      if (n % 2 === 0) return;

      var msg = document.createElement('div');
      msg.id = 'mj-cart-bundle-warning';
      msg.style.cssText = 'background:#faf6fa;border:1px solid #d9c9d9;border-radius:6px;padding:7px 10px;margin:0 0 8px;font-size:12px;color:#5a3a5a;line-height:1.35;';
      msg.innerHTML = 'Add one more from <a href="/collections/' + BUNDLE_HANDLE + '" style="color:#8B5A8B;font-weight:600;text-decoration:underline;">Bundle &amp; Save</a> to take '
        + BUNDLE_PCT + '% off both. <span style="color:#888;">Checkout is still available.</span>';

      var cartRoot = document.querySelector('#offcanvas-cart .offcanvas-footer')
        || document.querySelector('#cart-summary')
        || document.querySelector('#offcanvas-cart')
        || document.querySelector('#cart');
      var checkoutBtn = cartRoot && cartRoot.querySelector('.btn-checkout');
      if (checkoutBtn && checkoutBtn.parentNode) {
        checkoutBtn.parentNode.insertBefore(msg, checkoutBtn);
      }
    }).catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!document.getElementById('product-purchase-options')) return;

    var chosen = getChosenOption();
    window.mjSelectedOption = chosen;

    if (chosen === 'onetime') {
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (!variantInput) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantInput.value, 10),
          quantity: qty,
          properties: oneTimeProperty()
        })
      })
        .then(showCart)
        .catch(function () { form.submit(); });
      return;
    }

    if (chosen === 'subscription') {
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantInput = form.querySelector('[name="id"]');
      var spInput = document.getElementById('purchase-delivery-options-select');
      var spId = (spInput && spInput.value) ? parseInt(spInput.value, 10) : SELLING_PLAN_ID;
      if (!variantInput || !spId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1, selling_plan: spId })
      })
        .then(showCart)
        .catch(function (err) { console.error('MJ subscribe add failed:', err); });
      return;
    }

    if (chosen === 'bundle' && BUNDLE_TIER) {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitBundle(form);
      return;
    }
  }, true);

  window.addEventListener('variantChange.ecomify.product', function (e) {
    if (e.detail) updateSlot1(e.detail);
    updateAtcLabel();
  });

  document.addEventListener('show.bs.offcanvas', function (e) {
    if (e.target && e.target.id === 'offcanvas-cart') mjCheckBundleCart();
  });
  window.addEventListener('updated.ecomify.cart', mjCheckBundleCart);

  if (document.getElementById('mj-bundle-pick-modal') && window.bootstrap) {
    pickModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('mj-bundle-pick-modal'));
  }

  bindOpenModal(document.getElementById('mj-bc-open-modal'));

  var searchInput = document.getElementById('mj-bpm-search-input');
  if (searchInput) searchInput.addEventListener('input', applyModalFilter);

  fieldset.querySelectorAll('[name="purchase_option"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      setTimeout(function () {
        var chosen = getChosenOption();
        window.mjSelectedOption = chosen;
        syncSellingPlanField(chosen);
      }, 0);
    });
  });

  mjSelectOption(window.mjSelectedOption);
  updateBundlePrice();
  if (BUNDLE_TIER) loadCollectionProducts(false);
  mjCheckBundleCart();

  var subCard = document.querySelector('#mj-card-subscription');
  if (subCard && typeof bootstrap !== 'undefined') {
    subCard.setAttribute('data-bs-toggle', 'tooltip');
    subCard.setAttribute('data-bs-placement', 'top');
    subCard.setAttribute('data-bs-title', '3-month minimum, then $49/month. Cancel anytime.');
    new bootstrap.Tooltip(subCard);
  }
})();
